import { createSelector } from '@reduxjs/toolkit';
import { selectClientState } from '../../store/selectors';

export const selectGainsLosses = createSelector(selectClientState, (clientState) => clientState.gainsAndLosses);

export const selectResults = createSelector(selectGainsLosses, (gainsLosses) => gainsLosses.results);

export const selectParameters = createSelector(selectGainsLosses, (gainsLosses) => gainsLosses.parameters);

export const filteredResults = createSelector(selectResults, selectParameters, (results, parameters) => {
  const items = results?.items ?? [];
  const rawFilter = typeof parameters?.filter === 'string' ? parameters.filter : '';
  const filterText = rawFilter.trim().toLowerCase();

  if (filterText.length < 1) return items;

  return items.filter((i) => {
    const groupName = (i?.groupName ?? '').toLowerCase();
    const groupSubName = (i?.groupSubName ?? '').toLowerCase();
    return groupName.includes(filterText) || groupSubName.includes(filterText);
  });
});
